import {ProductSlider} from './modules/product-slider';

document.addEventListener('alpine:init', () => {
    Alpine.data('ProductSlider', ProductSlider);
});